import React, {Component} from 'react'
import {Route, Switch} from 'react-router-dom';
import * as notificationActions from "../../../notifications/actions/notificationActions";
import * as inboundProcessingActions from "../../actions/inboundProcessingActions";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import FormLoader from "../../../../components/common/FormLoader";
import FileImportLine from "./visualTracking/FileImportLine";

class InboundProcessingVisualTrackingTab extends Component {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            inboundProcessingId: this.props.inboundProcessingId,
            isLoading: false,
            isWorking: false
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.props.actions.clearVisualTrackingItems();
        this
            .props
            .actions
            .getVisualTrackingItems(this.state.inboundProcessingId)
            .then(() => {
                this.setState({isLoading: false})
            })
            .catch(() => {
                this.setState({isLoading: false})
            })
    }

    render() {
        return (
            <div className="relative">
                {this.state.isLoading
                    ? <FormLoader/>
                    : null}
                {this.props.inboundProcessings && this.props.inboundProcessings.inboundProcessing && this.props.inboundProcessings.inboundProcessing.exception?<div class="alert alert-danger margin-top-10">
                    <strong>Unhandled error!</strong> {this.props.inboundProcessings.inboundProcessing.exception}
                </div>:null}
                {(this.props.inboundProcessings && this.props.inboundProcessings.visualTrackingItems)?
                    this.props.inboundProcessings.visualTrackingItems.map(x=> {
                        return (<FileImportLine
                            history={this.props.history}
                            settings={this.props.settings}
                            key={x.fileImport.id}
                            item={x}
                            reprocess={this.props.reprocess}
                            saveData={this.props.saveData}
                        />);
                    }):null}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        inboundProcessings: state.inboundProcessing,
        settings: state.settings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(inboundProcessingActions, dispatch),
        notification: bindActionCreators(notificationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InboundProcessingVisualTrackingTab)